import * as types from "../types/shift.types";
import {SET_SHIFT_TYPES} from "../types/shift.types";

const initialState = {
  shigleShiftData: [],
  shiftData: [],
  shiftPagination: [],
  singleShiftRiderData: [],
  singleShiftRiderPagination: [],
  shiftTypes: [],
};

const ShiftReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_SINGLE_SHIFT_DATA:
      return { ...state, shigleShiftData: action.payload };
    case types.SET_SHIFT_DATA:
      return { ...state, shiftData: action.payload };
    case types.SET_SHIFT_PAGINATION:
      return { ...state, shiftPagination: action.payload };
    case types.SET_SINGLE_SHIFT_RIDER_DATA:
      return { ...state, singleShiftRiderData: action.payload };
    case types.SET_SINGLE_SHIFT_RIDER_PAGINATION:
      return { ...state, singleShiftRiderPagination: action.payload };
    case types.SET_SHIFT_TYPES:
      return { ...state, shiftTypes: action.payload };
    case types.RESET_SHIFT_REDUCER:
      return { 
        ...state, 
        shigleShiftData: [],
        shiftData: [],
        shiftPagination: [],      
        singleShiftRiderData: [],
        singleShiftRiderPagination: [],
      };
    default:
      return state;
  }
};
export default ShiftReducer;
